import { useEffect, useState } from "react";
import { Collection } from "../../domain/Collection";
import { User } from "../../domain/User";
import { useServicesContext } from "../../providers/ServicesProvider";
import { usePaginatedList } from "../usePaginatedList/usePaginatedList";
import { DEFAULT_PAGE_SIZE, SWR_KEY_PREFIX } from "../../constants/constants";
import { datadogRum } from "@datadog/browser-rum";

export const useAgents = ({
    organizationId,
    query = ""
}: {
    organizationId?: string;
    query?: string;
} = {}) => {
    const { userService } = useServicesContext();

    const [currentData, setCurrentData] = useState<User[] | undefined>(undefined);

    const { pageData, error, currentPage, setCurrentPage } = usePaginatedList<User>({
        key: organizationId
            ? `${SWR_KEY_PREFIX.AGENTS}:/api/users/${organizationId}?query=${query}&isVirtual=true`
            : null,
        fetcher: (): Promise<Collection<User>> => {
            return userService.getUsers({
                organizationId: organizationId as string,
                query,
                isVirtual: true,
                size: DEFAULT_PAGE_SIZE,
                page: currentPage
            });
        }
    });

    useEffect(() => {
        if (pageData) setCurrentData(pageData?.items);
    }, [pageData]);

    useEffect(() => {
        if (error) {
            datadogRum.addError(error);
        }
    }, [error]);

    return {
        agents: currentData,
        currentPage,
        setCurrentPage,
        isLoading: !error && !pageData,
        error,
        pageSize: DEFAULT_PAGE_SIZE,
        totalCount: pageData?.totalCount || 0
    };
};
